<template>
  <div class="c-mixcheck">
    <template v-for="item in value">
      <label :class="wrapClasses(item)" :key="item.label">
        <span class="c-check-item">
          <input
            type="checkbox"
            :class="inputClasses"
            :disabled="disabled || item.disabled"
            :checked="item.checked"
            @change="change($event, item)"
          />
        </span>
        <slot :name="item.label" :item="item">
          <span>{{ item.name }}</span>
        </slot>
      </label>
    </template>
  </div>
</template>

<script type="text/ecmascript-6">
import { deepCopy } from '@/common/js/utils'

export default {
  name: 'CheckPlus',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean
    },
    sameGroupCheck: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputClasses() {
      return 'c-mix-input'
    },
    wrapClasses() {
      return (item) => {
        return [
          'mixcheck-item',
          'c-check-wrapper',
          {
            'c-wrapper-checked': item.checked,
            'c-wrapper-disabled': this.disabled || item.disabled
          }
        ]
      }
    }
  },
  methods: {
    change(event, item) {
      const checked = event.target.checked
      const disabled = event.target.disabled
      const len = this.value.filter((ret) => ret.checked).length
      if (disabled) return false
      if ((len === 1 && !checked) || checked === item.checked) return false
      const oVal = deepCopy(this.value)
      let nVal = this.value.map((ret) => {
        return Object.assign({}, ret, {
          checked: ret.label === item.label ? checked : ret.checked
        })
      })
      // 同组选中
      if (this.sameGroupCheck && checked && !item.single) {
        nVal = nVal.map((ret) => {
          return Object.assign({}, ret, {
            checked: ret.group === item.group ? checked : ret.checked
          })
        })
      }
      // 单选排他、多选排单
      if (checked) {
        nVal = nVal.map((ret) => {
          if (item.single) {
            return Object.assign({}, ret, {
              checked: ret.label === item.label
            })
          } else {
            return Object.assign({}, ret, {
              checked: ret.single ? false : ret.checked
            })
          }
        })
      }
      this.$emit('input', nVal)
      this.$emit('on-change', { checked, select: item, nVal, oVal })
    }
  },
  data() {
    return {}
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.c-check-wrapper {
  min-width: 94px;
  text-align: center;
  position: relative;

  &:hover {
    color: #3990ec;
  }

  &:after {
    content: '';
    position: absolute;
    right: 0;
    top: -3px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid #dee4f5;
    transform: rotate(-45deg);
  }

  .c-mix-input {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    opacity: 0;
    cursor: pointer;
  }
}

.c-mixcheck {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  font-size: 0;

  ::v-deep .mixcheck-item {
    display: inline-block;
    font-size: 12px;
    height: 32px;
    line-height: 30px;
    padding: 0px 15px;
    color: #333;
    cursor: pointer;
    user-select: none;
    background-color: #fff;
    border: 1px solid #dcdee2;
    border-left: 0;

    &:first-child {
      border-left: 1px solid #dcdee2;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }

    &.c-wrapper-checked {
      color: #2b85e4;
      border-color: #2b85e4;
      box-shadow: -1px 0 0 0 #2d8cf0;
      z-index: 1;

      &:first-child {
        box-shadow: none;
      }

      &:after {
        border-left-color: #2b85e4;
      }
    }

    &.c-wrapper-disabled {
      color: #cccccc;
      background-color: #f7f7f7;
      border-color: #dcdee2;
      cursor: not-allowed;
      box-shadow: none !important;

      &:first-child {
        border-left-color: #dcdee2;
      }

      &.c-wrapper-checked {
        color: #ffffff;
        background-color: #e6e6e6;

        &:after {
          border-left-color: #95b5d6;
        }
      }
    }

    .c-mix-input {
      opacity: 0;
      width: 0;
      height: 0;
    }
  }
}
</style>
